import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import Snackbars from '../pages/Snackbars';
import Loader from '../pages/Loader';
import validator from 'validator';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import Select from "react-select";

function RegisterDemo(props) {
    const { t } = useTranslation();
    const history = useHistory();

    const [firstname, setFirstname] = useState('');
    const [firstname_error, setFirstnameError] = useState("");
    const [lastname, setLastname] = useState('');
    const [lastname_error, setLastnameError] = useState('');
    const [email, setEmail] = useState('');
    const [email_error, setEmailError] = useState('');
    const [phonenumber, setPhonenumber] = useState('');
    const [phonenumber_error, setPhonenumberError] = useState('');
    const [countrycode, setCountrycode] = useState('1');
    const [countrycode_error, setCountrycodeError] = useState('');
    const [Countriesdata, setCountriesData] = useState([]);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success_msg, setSuccessMsg] = useState("");
    const [loader, setLoader] = useState(false);
    const [logo, setLogo] = useState(false);
    const [newcode, setnewcode] = useState("");

    React.useEffect(() => {
        setLoader(true);
        handleLoad();
        handlelogo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handlelogo = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        }
        axios.get(process.env.REACT_APP_API_URL + 'getalllogo', { headers: headers })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    console.log(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
                    setLogo(process.env.REACT_APP_FILE_PATH_LOGO + res.data.whitelogo);
                }

            })
            .catch(function (error) {

            });
    }

    const handleLoad = () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
        }

        axios.get(process.env.REACT_APP_API_URL + 'findallCountries', {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    var TempArrfiat = [];
                    res.data.forEach(element => {
                        var fiatonetemp = {
                            value: element.phonecode,
                            label: "+" + element.phonecode + " " + element.name,
                        };
                        TempArrfiat.push(fiatonetemp);
                    });
                    setCountriesData(TempArrfiat);
                    setCountrycode("1");
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }
                setLoader(false);
            })
            .catch(function (error) {
                setLoader(false);
                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const validateFirstName = (value) => {
        setFirstname(value);
        if (!validator.isEmpty(value)) {
            setFirstnameError("");
            return true;
        } else {
            setFirstnameError(t('ERROR_MSG.ERROR_FIRSTNAME'));
            return false;
        }
    }

    const validateLastName = (value) => {
        setLastname(value);
        if (!validator.isEmpty(value)) {
            setLastnameError("");
            return true;
        } else {
            setLastnameError(t('ERROR_MSG.ERROR_LASTNAME'));
            return false;
        }
    }

    const validateEmail = (value) => {
        setEmail(value);
        if (validator.isEmail(value)) {
            setEmailError("");
            return true;
        } else {
            setEmailError(t('ERROR_MSG.ERROR_EMAIL'));
            return false;
        }
    }

    const validatephonenumber = (value) => {
        setPhonenumber(value);
        if (validator.isMobilePhone(value)) {
            setPhonenumberError("");
            return true;
        } else {
            setPhonenumberError(t('ERROR_MSG.ERROR_PHONENUMBER'));
            return false;
        }
    }

    const validateCountrycode = (value) => {
        if (value === null || value === undefined) {
            setCountrycodeError(t('ERROR_MSG.ERROR_COUNTRYCODE'));
            return false;
        } else {
            setCountrycode(value);
            if (!validator.isEmpty(value.value)) {
                setnewcode(value.value);
                setCountrycodeError("");
                return true;
            } else {
                setCountrycodeError(t('ERROR_MSG.ERROR_COUNTRYCODE'));
                return false;
            }
        }

    }



    const handlesubmit = () => {
        if (validateFirstName(firstname) === false) {
            setFirstnameError(t('ERROR_MSG.ERROR_FIRSTNAME'));
            return false;
        } else if (validateLastName(lastname) === false) {
            setFirstnameError("");
            setLastnameError(t('ERROR_MSG.ERROR_LASTNAME'));
            return false;
        } else if (validateEmail(email) === false) {
            setLastnameError("");
            setEmailError(t('ERROR_MSG.ERROR_EMAIL'));
            return false;
        } else if (newcode === null || newcode === undefined || newcode === "") {
            setCountrycode("");
            setCountrycodeError(t('ERROR_MSG.ERROR_COUNTRYCODE'));
            return false;
        } else if (validatephonenumber(phonenumber) === false) {
            setEmailError("");
            setPhonenumberError(t('ERROR_MSG.ERROR_PHONENUMBER'));
            return false;
        } else {
            setPhonenumberError("");
            var queryParams = new URLSearchParams(window.location.search);
            var Refcode = queryParams.get('ref_code');
            var RefcodeS = "";
            if (Refcode === "" || Refcode === null || Refcode === undefined) {
                RefcodeS = "";
            } else {
                RefcodeS = Refcode;
            }

            var jsonpar = JSON.stringify({
                'first_name': firstname,
                'last_name': lastname,
                'email_id': email,
                'phone_number': phonenumber,
                'country_code': newcode,
                'ref_code': RefcodeS
            });
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            }
            setLoader(true);

            axios.post(process.env.REACT_APP_API_URL + 'registerdemo', jsonpar, { headers: headers })
                .then(function (res) {
                    res = res.data;
                    if (res.code === "200") {
                        setLoader(false);
                        setSuccess(true);
                        setSuccessMsg(t('REGISTER_SUCCESS'));
                        setTimeout(() => {
                            setSuccess(false);
                            history.push('/demologin');
                        }, 1000);
                    } else {
                        setLoader(false);
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    }

                })
                .catch(function (error) {
                    setLoader(false);
                    setError(true);
                    setErrorMsg(t('ERROR_MSG.SOMETHING'));
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });
        }
    }

    return (
        <div className="vh-100 login-main-page p-0">
            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
            {success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}
            {loader === true ? <div><Loader open_close={loader} /></div> : ""}
            <div className="row m-0 justify-content-center h-100 align-items-center">
                <div className="login-wrapper">
                    <div className="login-aside-right">
                        <div className="col-xl-12">
                            <div className="authincation-content">
                                <div className="row no-gutters">
                                    <div className="col-xl-12">
                                        <div className="auth-form-1">
                                            <div className="mb-5">
                                                <Link to="/register" className="login-logo1 logo-center">
                                                    <img src={logo} alt="" className='mb-4 logo' />
                                                </Link>
                                                <h4 className="text-white mb-1 text-center login-text">Request for Demo</h4>
                                            </div>


                                            <div className='form-group'>
                                                <label className='mb-1 text-white'>{t('LABEL.LABEL_FIRST_NAME')}</label>
                                                <input type='text' value={firstname} onChange={(e) => validateFirstName(e.target.value)} className='form-control' placeholder={t('PLACEHOLDER.PLACEHOLDER_FIRST_NAME')} />
                                                {firstname_error !== "" ? <label className='text-red'>{firstname_error}</label> : ""}
                                            </div>
                                            <div className='form-group'>
                                                <label className='mb-1 text-white'>{t('LABEL.LABEL_LAST_NAME')}</label>
                                                <input type="text" value={lastname} onChange={(e) => validateLastName(e.target.value)} className="form-control" placeholder={t('PLACEHOLDER.PLACEHOLDER_LAST_NAME')} />
                                                {lastname_error !== "" ? <label className='text-red'>{lastname_error}</label> : ""}
                                            </div>
                                            <div className='form-group'>
                                                <label className='mb-1 text-white'>{t('LABEL.LABEL_EMAIL')}</label>
                                                <input type="text" value={email} onChange={(e) => validateEmail(e.target.value)} className="form-control" placeholder={t('PLACEHOLDER.PLACEHOLDER_EMAIL')} />
                                                {email_error !== "" ? <label className='text-red'>{email_error}</label> : ""}
                                            </div>
                                            <div className='form-group  mb-2 fullWidth'>
                                                <label className='mb-1 text-white fullWidth'>{t('LABEL.LABEL_PHONE_NUMBER')}</label>
                                                <div className="form-group position-relative">
                                                    <div className="dropdown-container">
                                                        <Select
                                                            options={Countriesdata}
                                                            placeholder="Select Country Code"
                                                            value={countrycode}
                                                            onChange={validateCountrycode}
                                                            isSearchable={true}
                                                        />
                                                    </div>
                                                    {/* <select className="form-control webkit-none" value={countrycode} onChange={(e) => validateCountrycode(e.target.value)}>
                                                        {Countriesdata && Countriesdata.map((row) => (
                                                            <option value={row.phonecode} key={row.country_id_pk}>+{row.phonecode + " " + row.name}</option>
                                                        ))}
                                                    </select>
                                                    <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i> */}
                                                </div>
                                                {countrycode_error !== "" ? <label className='text-red'>{countrycode_error}</label> : ""}
                                            </div>

                                            <div className='text-center mt-4'>
                                                <input type="text" value={phonenumber} onChange={(e) => validatephonenumber(e.target.value)} className="form-control" placeholder={t('PLACEHOLDER.PLACEHOLDER_PHONE_NUMBER')} />
                                                {phonenumber_error !== "" ? <label className='text-red'>{phonenumber_error}</label> : ""}
                                            </div>
                                            <div className='text-center mt-4'>
                                                <button type="button" id="submit" onClick={handlesubmit} className="btn btn-login-hover bg-white text-primary btn-block" > {t('BUTTONS.SIGNUP_BUTTON')}  </button>
                                            </div>

                                            <div className='new-account mt-5'>
                                                <p className='text-white text-center'> {t('ALREADY_ACCOUNT')} <Link className="text-white color-bg-link" to='/demologin'> {t('LINK.SIGN_IN')} </Link> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegisterDemo;
